import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Select } from '@/components/base/select'
import type { ItemTypeDetailFragment } from '@/gql/graphql'
import { StepActionsContext } from '@/helpers/useTestDefinition'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'
import { useContext } from 'react'

type HipotNode = Node<{ name: string, connectorFamilies: ItemTypeDetailFragment['connectorFamilies'], steppable: { voltage: number, connectorFamilyPinId: string } }, 'HipotTestStepType'>

export const HipotNode = ({ id, data }: NodeProps<HipotNode>) => {
  const { changeStep } = useContext(StepActionsContext)

  const connectorFamilyPinOptions = data.connectorFamilies.reduce((acc, connectorFamily) => {
    connectorFamily.connectorFamilyPins.forEach(pin => {
      acc[pin.id] = { value: pin.id, label: `${connectorFamily.name} - ${pin.name}`, detail: pin.role }
    })
    return acc
  }, {} as { [id: string]: { value: string, label: string, detail: string } })

  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-1 gap-2 items-center justify-around h-full">
          <div className="text-center"><Badge color="red">Hipot</Badge></div>
          <Field>
            <Label>Name</Label>
            <Input value={ data.name } onChange={ e => changeStep(id, { name: e.target.value }) } />
          </Field>
          <Field>
            <Label>Voltage</Label>
            <Select value={ data.steppable.voltage } onChange={ e => changeStep(id, { steppable: { voltage: parseInt(e.target.value) } }) }>
              <option value="500">500V</option>
              <option value="1000">1kV</option>
              <option value="1500">1.5kV</option>
            </Select>
          </Field>
          <Field>
            <Label>Connector pin (for each net)</Label>
            <Select value={ data.steppable.connectorFamilyPinId } onChange={ e => changeStep(id, { steppable: { connectorFamilyPinId: e.target.value } }) }>
              { Object.values(connectorFamilyPinOptions).map(option => <option value={ option.value }>{ option.label }</option>) }
            </Select>
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
